import {
  getHasMatchInsufficientCoverage,
  getHasMatchScore,
  getIsMatchNotEligible,
} from '../RentalPortalMatch.utils'

export function getMatchFitCellScoreState({ isScoreOnly, match }) {
  if (getHasMatchScore(match)) {
    return { hasCoverage: !isScoreOnly, hasRing: true }
  }

  if (getHasMatchInsufficientCoverage(match)) {
    return isScoreOnly ? { hasDash: true } : { hasCoverage: true }
  }

  return getIsMatchNotEligible(match.eligibility)
    ? { hasDash: true }
    : { dashTooltipKey: 'RentalPortal.MatchNotEvaluatedKey', hasDash: true }
}
